import * as CreDtos from "../CRE.dtos";
import { Certificate } from "crypto";


export const
    PEOPLE_REQUEST = "PEOPLE_REQUEST",
    PEOPLE_REQUEST_FAILURE = "PEOPLE_REQUEST_FAILURE",
    PEOPLE_REQUEST_SUCCESS = "PEOPLE_REQUEST_SUCCESS",
    PEOPLE_FILTER = "PEOPLE_FILTER",
    PEOPLE_ADD = "PEOPLE_ADD",
    PEOPLE_EDIT = "PEOPLE_EDIT",
    PEOPLE_CANCEL = "PEOPLE_CANCEL",
    PEOPLE_UPSERT_REQUEST = "PEOPLE_UPSERT_REQUEST",
    PEOPLE_UPSERT_REQUEST_FAILURE = "PEOPLE_UPSERT_REQUEST_FAILURE",
    PEOPLE_UPSERT_REQUEST_SUCCESS = "PEOPLE_UPSERT_REQUEST_SUCCESS"

export function peopleRequest() {
    return {
        type: PEOPLE_REQUEST
    };
}

export function peopleRequestSuccess(people: CreDtos.People[], categories: CreDtos.Category[]) {
    return {
        type: PEOPLE_REQUEST_SUCCESS,
        people,
        categories
    };
}

export function peopleRequestFailure(error) {
    return {
        type: PEOPLE_REQUEST_FAILURE,
        error
    };
}

export function peopleFilter(search: string, category: number, showDisabled: boolean, showInternal: boolean, showExternal: boolean) {
    return {
        type: PEOPLE_FILTER,
        search,
        category,
        showDisabled,
        showInternal,
        showExternal
    }
}

export function peopleAdd() {
    return {
        type: PEOPLE_ADD
    }
}

export function peopleEdit(person: CreDtos.People) {
    return {
        type: PEOPLE_EDIT,
        person
    }
}

export function peopleCancel() {
    return {
        type: PEOPLE_CANCEL
    }
}

export function peopleUpsertRequest(people: CreDtos.People) {
    return {
        type: PEOPLE_UPSERT_REQUEST,
        people
    };
}

export function peopleUpsertRequestSuccess(people: CreDtos.People) {
    return {
        type: PEOPLE_UPSERT_REQUEST_SUCCESS,
        people
    };
}

export function peopleUpsertRequestFailure(error) {
    return {
        type: PEOPLE_UPSERT_REQUEST_FAILURE,
        error
    };
}




// WEBPACK FOOTER //
// ./src/actions/people.actions.ts